import { Store } from "pullstate";
import { TradeHistoryData } from "../../types/history";
import { TokenList } from "../global/getAllTokenLists";
import { attachReactions } from "./reactions";

export interface IActivityStore {
  history: { data: TradeHistoryData | undefined; isLoading: boolean; error: Error | undefined };
  tokens: TokenList | undefined;
}

export const INITIAL_STATE_ACTIVITY = {
  tokens: undefined,
  history: { data: undefined, isLoading: false, error: undefined },
};

export const ActivityStore = new Store<IActivityStore>(INITIAL_STATE_ACTIVITY);

attachReactions();
